/* eslint-disable react/prop-types */
import React, { Component } from 'react';

import ReCAPTCHA from 'react-google-recaptcha'
import Container from 'blocks/Container/Container';
import { inject, observer } from 'mobx-react';
import { Column, Row } from 'hedron';
import PropTypes from 'prop-types';
import { ContactForm as ContactFormModel } from 'models';
import CustomForm from 'blocks/Form/CustomForm';
import CustomFormElement from 'blocks/Form/CustomFormElement';
// restore below when privacy policy agreement is required
// import CustomCheckbox from 'blocks/Form/CustomCheckbox';
import SubmitButton from 'blocks/Form/SubmitButton';
import { Bind } from 'lodash-decorators';

import MailingService from 'services/Mailing.service';
import FORM from 'common/consts/form';
// restore below when privacy policy agreement is required
// import { removeTags } from 'common/methods/string';
import ds from 'designsystem';
import HTMLModifiableBackground from 'blocks/HTMLModifableBackground/HTMLModifiableBackground';
// restore below when privacy policy agreement is required
// import styled from 'styled-components';

// restore below when privacy policy agreement is required
// const CheckboxContainer = styled.div`
//   transition: all 0.35s ease-out;
//   transform-origin: 50% 75%;
//   position: relative;
//
//   ${({ visible }) => (visible
//     ? 'transform: scaleY(1); margin-top: 0; opacity: 1;'
//     : `transform: scaleY(0.33); margin-top: -${ds.get('metrics.xxl')}; opacity: 0;`)};
// `;

// cancel below when privacy policy agreement is required
@inject('appStore')
// restore below when privacy policy agreement is required
// @inject("windowStore", "coreStore", 'appStore')
@observer
class ContactForm extends Component {
  constructor(props) {
    super(props);
    this.captchaRef = React.createRef();
    this.state = {
      formData: {
        body: '',
        email: '',
        firstName: '',
        lastName: '',
        phone: '',
        dataProcessingCheckbox: false,
        dataSendingCheckbox: false,
      },
      buttonState: '',
      resetValue: false,
      country: 'PL',
      clientIP: '',
      showReCAPTCHA: false,
      isReCAPTCHAError: false,
      // restore below when privacy policy agreement is required
      // isRodoVisible: false,
    };
    this.checkReCAPTCHA();
  }

  componentDidMount() {
    fetch(process.env.REACT_APP_GEOLOCATION_API)
      .then(response => response.json())
      .then(jsonResponse => this.setState({clientIP: jsonResponse.ip}, () => this.checkReCAPTCHA()));
  }

  checkReCAPTCHA() {
    MailingService.spamBotDetected(this.state.clientIP, "check").then(res => this.setState({showReCAPTCHA: res}));
  }

  @Bind
  async submitForm(submitEvent) {
    submitEvent.preventDefault();
    const {
      appStore: {
        referrer,
        currentUrl,
        previousUrl,
      },
    } = this.props;
    const {
      formData: {
        firstName,
        lastName,
        phone,
        email,
        body,
      },
    } = this.state;

    try {
      if (this.state.showReCAPTCHA) {
        const token = this.captchaRef.current.getValue();
        if (!token) {
          this.setState({isReCAPTCHAError: true});
          return;
        }
        MailingService.spamBotDetected(this.state.clientIP, "submit", token).then(res => this.setState({showReCAPTCHA: res}))
      } else {
        MailingService.spamBotDetected(this.state.clientIP, "submit").then(res => this.setState({showReCAPTCHA: res}))
      }

      this.setState({
        buttonState: FORM.BUTTON_STATE.LOADING,
      });
  
      fetch(process.env.REACT_APP_GEOLOCATION_API)
        .then(response => response.json())
        .then(jsonResponse => this.setState({country: jsonResponse.country}));
      
      const data = {
        firstName,
        lastName,
        phone,
        email,
        body,
        source: referrer,
        url: currentUrl,
        referrer: previousUrl,
        country: this.state.country,
      }

      await MailingService.sendContactForm(data);

      if (await MailingService.sendPipedrive(data)) {
        this.setState({
          buttonState: FORM.BUTTON_STATE.SUCCESS,
        });
  
        setTimeout(() => {
          this.resetState();
        }, FORM.SUCCESS_MESSAGE_TIMEOUT);
  
        this.setState({
          resetValue: false,
        });
      } else {
        throw new Error();
      }
    } catch (e) {
      this.setState({
        buttonState: FORM.BUTTON_STATE.ERROR,
      });
    }
  }

  resetState() {
    this.setState({
      formData: {
        body: '',
        email: '',
        firstName: '',
        lastName: '',
        phone: '',
        dataProcessingCheckbox: false,
        dataSendingCheckbox: false,
      },
      buttonState: '',
      resetValue: true,
    });
  }

  @Bind
  updateInputValue(input) {
    const { inputName } = input;
    const { formData } = this.state;

    formData[inputName] = input.value;

    this.setState({ formData });
  }

  // restore below when privacy policy agreement is required
  // @Bind
  // showRodoCheckboxes() {
  //   this.setState({
  //     isRodoVisible: true,
  //   });
  // }

  render() {
    const {
      data: {
        emailLabel,
        firstNameLabel,
        lastNameLabel,
        phoneLabel,
        messageLabel,
        reCaptchaErrorMessage,
        htmlModifiers,
      },
      // restore below when privacy policy agreement is required
      // windowStore,
      // coreStore: { translations },
    } = this.props;

    // cancel below when privacy policy agreement is required
    const { buttonState, resetValue } = this.state;

    // restore below when privacy policy agreement is required
    // const { buttonState, resetValue, isRodoVisible } = this.state;

    return (
      <HTMLModifiableBackground
        htmlModifiers={htmlModifiers}
        color={ds.brand('white')}
      >
        <CustomForm onSubmit={this.submitForm} className="GA-form-contact">
          <Container>
            <Row divisions={11}>
              <Column lg={5}>
                <CustomFormElement
                  type="text"
                  name="firstName"
                  required
                  labelName={firstNameLabel}
                  validateOnInput
                  getValue={this.updateInputValue}
                  resetValue={resetValue}
                  // restore below when privacy policy agreement is required
                  // onInput={this.showRodoCheckboxes}
                />
              </Column>
              <Column lg={5} lgShift={1}>
                <CustomFormElement
                  type="text"
                  name="lastName"
                  required
                  labelName={lastNameLabel}
                  validateOnInput
                  getValue={this.updateInputValue}
                  resetValue={resetValue}
                  // restore below when privacy policy agreement is required
                  // onInput={this.showRodoCheckboxes}
                />
              </Column>
            </Row>
            <Row divisions={11}>
              <Column lg={5}>
                <CustomFormElement
                  type="tel"
                  name="phone"
                  required
                  pattern="^[0-9-+\s()]*$"
                  labelName={phoneLabel}
                  validateOnInput
                  getValue={this.updateInputValue}
                  resetValue={resetValue}
                  // restore below when privacy policy agreement is required
                  // onInput={this.showRodoCheckboxes}
                />
              </Column>
              <Column lg={5} lgShift={1}>
                <CustomFormElement
                  type="email"
                  name="email"
                  required
                  labelName={emailLabel}
                  validateOnInput
                  getValue={this.updateInputValue}
                  resetValue={resetValue}
                  // restore below when privacy policy agreement is required
                  // onInput={this.showRodoCheckboxes}
                />
              </Column>
            </Row>
            <Row divisions={11}>
              <Column lg={11}>
                <CustomFormElement
                  type="textarea"
                  name="body"
                  labelName={messageLabel}
                  required
                  validateOnInput
                  getValue={this.updateInputValue}
                  resetValue={resetValue}
                  // restore below when privacy policy agreement is required
                  // onInput={this.showRodoCheckboxes}
                />
              </Column>
            </Row>
            {this.state.showReCAPTCHA && (
              <Row divisions={11}>
                <Column lg={3}>
                  <ReCAPTCHA 
                    sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
                    ref={this.captchaRef}
                  />
                  {this.state.isReCAPTCHAError && (<p style={{"color": "red"}}>{reCaptchaErrorMessage}</p>)}
                </Column>
              </Row>
            )}

            {/* restore below when privacy policy agreement is required */}

            {/* <CheckboxContainer visible={isRodoVisible}> */}
            {/*  <Row divisions={12} justifyContent="space-between"> */}
            {/*    {removeTags(translations.FORM_CHECKBOX_DATA_PROCESSING_LABEL) && ( */}
            {/*      <Column lg={3}> */}
            {/*        <CustomCheckbox */}
            {/*          type="checkbox" */}
            {/*          name="dataProcessingCheckbox" */}
            {/*          checkboxText={ */}
            {/*            translations.FORM_CHECKBOX_DATA_PROCESSING_LABEL */}
            {/*          } */}
            {/*          // required */}
            {/*          getValue={this.updateInputValue} */}
            {/*          resetValue={resetValue} */}
            {/*        /> */}
            {/*      </Column> */}
            {/*    )} */}
            {/*    {removeTags(translations.FORM_CHECKBOX_DATA_SENDING_LABEL) && ( */}
            {/*      <Column lg={3} lgShift={1}> */}
            {/*        <CustomCheckbox */}
            {/*          type="checkbox" */}
            {/*          name="dataSendingCheckbox" */}
            {/*          checkboxText={translations.FORM_CHECKBOX_DATA_SENDING_LABEL} */}
            {/*          required */}
            {/*          getValue={this.updateInputValue} */}
            {/*          resetValue={resetValue} */}
            {/*        /> */}
            {/*      </Column> */}
            {/*    )} */}
            {/*    {!windowStore.isOnTablet && <Column lg={3} lgShift={1} />} */}
            {/*  </Row> */}
            {/* </CheckboxContainer> */}
            <Row divisions={11}>
              <Column lg={11}>
                <SubmitButton centered buttonState={buttonState} />
              </Column>
            </Row>
          </Container>
        </CustomForm>
      </HTMLModifiableBackground>
    );
  }
}
ContactForm.propTypes = {
  data: PropTypes.instanceOf(ContactFormModel).isRequired,
};

export default ContactForm;



// WEBPACK FOOTER //
// ./src/kentico-blocks/ContactForm/index.jsx